export function evaluateComparison(leftOperand, operator, rightOperand) {
  switch (operator) {
    case "=":
      return leftOperand === rightOperand;
    case "!=":
      return leftOperand !== rightOperand;
    case "<":
      return leftOperand < rightOperand;
    case "<=":
      return leftOperand <= rightOperand;
    case ">":
      return leftOperand > rightOperand;
    case ">=":
      return leftOperand >= rightOperand;
    default:
      throw new Error(`Unsupported operator: ${operator}`);
  }
}

export default evaluateComparison;
